// extracted by mini-css-extract-plugin
export default {"dialog":"Styles_dialog__9atkU","limit":"Styles_limit__jYDAJ"};